// extracted by css-extract-rspack-plugin
var _1 = "src-components-Chat-ActionPopup-ActionPopup-module__actionPopup-e1GrQ5";
var _2 = "src-components-Chat-ActionPopup-ActionPopup-module__authorMessage-QU61cj";
var _3 = "src-components-Chat-ActionPopup-ActionPopup-module__deleteMessage-VqtlOD";
var _4 = "src-components-Chat-ActionPopup-ActionPopup-module__receiverMessage-f03HxQ";
export { _1 as "actionPopup", _2 as "authorMessage", _3 as "deleteMessage", _4 as "receiverMessage" }

    if(module.hot) {
      (function() {
        var localsJsonString = "{\"actionPopup\":\"src-components-Chat-ActionPopup-ActionPopup-module__actionPopup-e1GrQ5\",\"authorMessage\":\"src-components-Chat-ActionPopup-ActionPopup-module__authorMessage-QU61cj\",\"deleteMessage\":\"src-components-Chat-ActionPopup-ActionPopup-module__deleteMessage-VqtlOD\",\"receiverMessage\":\"src-components-Chat-ActionPopup-ActionPopup-module__receiverMessage-f03HxQ\"}";
        // 1752373455136
        var cssReload = require("../../../../node_modules/.pnpm/@rspack+core@1.4.6_@swc+helpers@0.5.17/node_modules/@rspack/core/dist/cssExtractHmr.js").cssReload(module.id, {});
        // only invalidate when locals change
        if (
          module.hot.data &&
          module.hot.data.value &&
          module.hot.data.value !== localsJsonString
        ) {
          module.hot.invalidate();
        } else {
          module.hot.accept();
        }
        module.hot.dispose(function(data) {
          data.value = localsJsonString;
          cssReload();
        });
      })();
    }
  